<template>
	<v-app id="inspire">

		<router-view />

	</v-app>
</template>

<script>
import i18n from './i18n';

export default {
	name: "App",
	props: { errors: Array },
	created: function() {
		if (this.$route.query.lang) {
			i18n.locale = this.$route.query.lang;
			this.$vuetify.rtl = i18n.locale == 'he';
		}
	}
};
</script>
